<div
  class="alert-box mat-elevation-z2"
  role="alert"
  [ngClass]="styleType"
>
  <mat-icon class="alert-icon">{{ styleType }}</mat-icon>
  <p [innerHTML]="message"></p>
</div>
